module.exports = {
	"buying": "Acheter",
	"categories": "Catégories",
	"dashboard": "Tableau de bord",
	"invoices": "Factures",
	"logout": "Déconnexion",
	"miscToggleNavigation": "Afficher navigation",
	"myAccount": {
		"header": "Mon compte",
		"profile": "Profil",
		"informationUpdated": "Information mise à jour!",
		"organizations": "Comptes d'encanteurs",
		"sellerRequests": "Requêtes d'adhésion",
		"settings": "Paramètres",
		"updateProfileBtn": "Mise à jour du profil",
		"userModel": "Modèle d'utilisateur"
	},
	"sellerDashboard": "Compte de vendeur",
	"sellerDashboard_plural": "Comptes de vendeur",
	"sellerDirectory": "Répertoire des encanteurs",
	"selling": "Vendre",
	"versionManager": "Gestionnaire de versions"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/menu.json5
// module id = 1993
// module chunks = 6